import { useEffect, useState } from 'react';
import LocationForm from '../../components/fees/LocationForm';
import VehicleInfoForm from '../../components/fees/VehicleInfoForm';
import TransactionForm from '../../components/fees/TransactionForm';
import CustomBreadcrumbs from '../../components/common/CustomBreadcrumbs';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectFeeLoadingState,
  selectFeesError,
} from '../../redux-state/fees/selectors';
import CircularIndeterminate from '../../components/common/Progress';
import ErrorDialog from '../../components/common/error-dialog';
import { selectLocationInfo, selectTransactionInfo, selectVehicleInfo } from '../../redux-state/selectors';
import { SUBMIT_FEES_FORM } from '../../redux-state/types';
import FormValidation from '../../components/utility/formValidation';
import scrollToFirstError from '../../components/utility/scrollToFirstError';
import PrimaryButton from '../../components/common/button/PrimaryButton';
import SecondaryButton from '../../components/common/button/SecondaryButton';

function Fee({ formErrors }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [errors, setErrors] = useState({});

  const locationInfo = useSelector(selectLocationInfo);
  const vehicleInfo = useSelector(selectVehicleInfo);
  const transactionInfo = useSelector(selectTransactionInfo);
  const loadingState = useSelector(selectFeeLoadingState);
  const backendError = useSelector(selectFeesError);

  useEffect(() => {
    if (formErrors) {
      setErrors(formErrors);
    }
  }, [formErrors]);

  const isOutput = location.pathname.includes('feesOutput');
  const isMultiStep = location.state?.fromMultiStep;
  if (isOutput) return <Outlet />;

  const handleSubmit = () => {
    const formData = { ...locationInfo, ...vehicleInfo, ...transactionInfo };

    const validationResult = FormValidation('Fees', formData);

    if (validationResult) {
      setErrors(validationResult);
      scrollToFirstError();
      return;
    }

    setErrors({});

    dispatch({
      type: SUBMIT_FEES_FORM,
      navigate: navigate,
      defaultNaviagtion: true,
      clearFormsOnSuccess: true,
    });
  };


  const handleSubmitBack = () => {
    navigate('/dashboard');
  };

  const handleCloseError = () => {
    dispatch({ type: 'CLEAR_FEES_ERROR' });
  };

  return (
    <>
      <div className="p-6 min-h-[700px]">
        <div className="mb-4">
          <CustomBreadcrumbs title={'Fees'} />
        </div>
        <div className="text-3xl font-bold text-gray-900"> Fees </div>
        <div className="mt-2 text-gray-600"> All your vehicle-related fees - transparent, accurate, and easy to access.</div>

        <div className="flex flex-col lg:flex-row w-full gap-6 mb-4">
          <div className="flex flex-col gap-6 mt-4 w-full lg:w-1/2">
            <LocationForm errors={errors} />
            <TransactionForm errors={errors} />
          </div>
          <div className="flex flex-col gap-6 mt-4 w-full lg:w-1/2">
            <VehicleInfoForm errors={errors} />
          </div>
        </div>
      </div>

      {loadingState && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <CircularIndeterminate />
        </div>
      )}

      { !isMultiStep &&
        <div className="flex flex-row justify-between bg-white p-6">
          <SecondaryButton
            text="Back to Home"
            onClick={handleSubmitBack}
          />

          <PrimaryButton
            text="Submit"
            onClick={handleSubmit}
            disabled={loadingState}
          />
        </div>
      }
      { !isMultiStep && <ErrorDialog backendError={backendError} onClose={handleCloseError} /> }
    </>
  );
}

export default Fee;